export const dropdownBancos = [
  { name: "Banco do Brasil", value: "BB" },
  // { name: "Cetelem", value: "CETELEM" },
  // { name: "Banrisul", value: "BANRISUL" },
  { name: "BMG", value: "BMG" },
  { name: "Bradesco", value: "BRADESCO" },
  { name: "C6", value: "C6" },
  { name: "Daycoval", value: "DAYCOVAL" },
  { name: "Facta", value: "FACTA" },
  { name: "Itaú", value: "ITAU" },
  { name: "Master", value: "MASTER" },
  { name: "Olé", value: "OLE" },
  { name: "PAN", value: "PAN" },
  { name: "PagBank", value: "PAGBANK" },
  { name: "Safra", value: "SAFRA" },
  { name: "Crefisa", value: "CREFISA" },
  { name: "Lotus", value: "LOTUS_TAYA" },
  { name: "VCTeX CDC", value: "VCTEX_CDC" },
  { name: "VCTeX QITech", value: "VCTEX_QITECH" },
  { name: "Tá Quitado BMP", value: "TA_QUITADO_BMP" },
  { name: "Santander", value: "SANTANDER" },
  { name: "Bradesco Digio", value: "BRADESCO_DIGIO" },
  { name: "iCred", value: "ICRED" },
  { name: "Presença", value: "PRESENCA" },
  { name: "Novo Saque", value: "NOVO_SAQUE" },
  { name: "X3 BMP", value: "X3_BMP" },
  { name: "V8 BMS", value: "V8_BMS" },
  { name: "V8 QITech", value: "V8_QITECH" },
  { name: "V8 Cartos", value: "V8_CARTOS" },
  { name: "Simplix", value: "SIMPLIX" },
  { name: "2S Consig", value: "TWO_S_CONSIG" },
];

export const dropdownBancosTabelas = [
  { name: "FACTA", value: "FACTA" },
  { name: "PAN", value: "PAN" },
  { name: "BMG", value: "BMG" },
  { name: "MASTER", value: "MASTER" },
];

export const dropdownBancosDigitacao = [
  { name: "Facta", value: "FACTA" },
  { name: "C6", value: "C6" },
  { name: "Pan", value: "PAN" },
  { name: "BMG", value: "BMG" },
  { name: "Master", value: "MASTER" },
  { name: "Daycoval", value: "DAYCOVAL" },
  { name: "Presença", value: "PRESENCA" },
  { name: "iCred", value: "ICRED" },
  { name: "Itaú", value: "ITAU" },
  { name: "Lotus", value: "LOTUS_TAYA" },
  { name: "VCTeX CDC", value: "VCTEX_CDC" },
  { name: "VCTeX QITECH", value: "VCTEX_QITECH" },
  { name: "Ta Quitado BMP", value: "TA_QUITADO_BMP" },
  { name: "Simplix", value: "SIMPLIX" },
  { name: "X3 BMP", value: "X3_BMP" },
  { name: "Novo Saque", value: "NOVO_SAQUE" },
  { name: "V8 BMS", value: "V8_BMS" },
  { name: "V8 QITECH", value: "V8_QITECH" },
  { name: "V8 CARTOS", value: "V8_CARTOS" },
  { name: "2S Consig", value: "TWO_S_CONSIG" },
];
